/**
 * Utilities for HTML-aware inline diffing (editor review mode, see components/editor/reviewEngine.js).
 */

/**
 * Splits HTML into atomic tokens: each `<...>` tag is one token; text between tags is kept as segments.
 * Prevents word-based diffs from breaking inside tag names (e.g. splitting `</colgroup><thead>`).
 * @param {string} html - Raw HTML string.
 * @returns {string[]} Non-empty token sequence.
 */
export function tokenizeHtmlForDiff(html) {
  if (!html || typeof html !== 'string') return [];
  const tokens = [];
  const tagRe = /<[^>]+>/g;
  let lastIndex = 0;
  let m = tagRe.exec(html);
  while (m !== null) {
    if (m.index > lastIndex) {
      const text = html.slice(lastIndex, m.index);
      if (text) tokens.push(text);
    }
    tokens.push(m[0]);
    lastIndex = m.index + m[0].length;
    m = tagRe.exec(html);
  }
  if (lastIndex < html.length) {
    const tail = html.slice(lastIndex);
    if (tail) tokens.push(tail);
  }
  return tokens;
}

/**
 * Stringifies a chunk from `diffArrays` (values are arrays of tokens).
 * @param {{ value?: string | string[] }} part - One diff segment.
 * @returns {string} Concatenated segment text.
 */
export function diffPartValueToString(part) {
  const v = part?.value;
  if (Array.isArray(v)) return v.join('');
  if (v == null) return '';
  return String(v);
}
